module.exports = __webpack_public_path__ + "img/blog-single.abe92e52.jpg";